import Vue from 'vue';
import axios from '../_helpers/axios';
import ProductCart from './ProductCart.vue';
import '../_helpers/vue-tippy';
import '../_helpers/vue-mq';

Vue.prototype.$http = axios;

document.querySelectorAll('[data-app-product-cart]').forEach((el) => {
    new Vue({
        render: h => h(ProductCart),
        beforeMount() {
            this.$config = JSON.parse(this.$el.dataset.config);
        },
    }).$mount(el);
});
